module.exports = __webpack_public_path__ + "media/components/src/assets/images/heading_with_sub/heading_with_sub_7-66f8800c807f9c8b65fd3dbd31c66376.png";